const ptPT= {
    login: {
      title: 'Iniciar sessão',
      sign_in_btn: 'Iniciar sessão'
    },
    bar: {
        logout: 'Encerrar sessão',
        languages: 'Idiomas',
        settings: 'Abrir Definições'
    },
    language: {
      name: 'Português (PT)',
    },
    attributePage: {
        title: 'Alterações dos atributos',
        viewChanges: 'Ver alterações',
        dateTime: 'Data',
        notificationType: 'Tipo de notificação',
        notificationValue: 'Valor da notificação',
        oldValue: 'Valor antigo',
        newValue: 'Valor novo',
        accept: 'Aceitar',
        reject: 'Rejeitar',
    },
    Home: 'Página inicial',
    load: 'A realizar carregamento inicial...',
    Requested: "Solicitado",
    Viewed: "Visto",
    Executing: "Em execução",
    Completed: "Concluído",
    Expired: "Expirado",
    Cancelled: "Cancelado",
    Error: "Erro",
    Rejected: "Rejeitado",
    error: 'Ocorreu um erro; tente novamente mais tarde.',
    displayname: 'Nome a apresentar',
    givenname: 'Nome próprio',
    surname: 'Último nome',
    email: 'E-mail',
    mail: 'E-mail',
    name: 'Nome próprio',
    firstname: 'Nome próprio',
    lastname: 'Último nome',
    footer_copyright: 'Todos os direitos reservados.'
  };
  
  export default ptPT;
  